import React from 'react';
import { Link } from 'react-router-dom';
import { useGallery } from '../../hooks/useGallery';
import { galleryPhotoAlt } from '../../utils/galleryAlbums';

export default function GalleryTeaser() {
  const { items, total, loading } = useGallery({ limitTo: 6 });

  if (loading) return null;

  return (
    <section className="mt-section mt-section--tight" id="galerie">
      <div className="mt-container">
        <div className="mt-head">
          <span className="mt-kicker">Galerie</span>
          <h2>Aus unseren Ausfahrten</h2>
        </div>

        {items.length === 0 ? (
          <div className="mt-card mt-empty">
            <p>
              Die Galerie fuellt sich nach den nächsten Treffen. Bis dahin: Fotos aus der
              Community sind jederzeit willkommen.
            </p>
          </div>
        ) : (
          <>
            <div className="mt-gallery">
              {items.map((item, i) => (
                <figure key={item.id} className="mt-gallery__item">
                  {/* Ohne Gesamtzahl: Der Teaser zeigt einen Ausschnitt quer
                      durch alle Alben, "Foto 2 von 6" waere eine Menge, die
                      es so nirgends gibt. Statt des Albums (das hier keines
                      ist) der Clubname - sonst bliebe nur "Foto 1", und das
                      sagt weniger als der bisherige Rueckfall. */}
                  <img
                    src={item.imageUrl}
                    alt={galleryPhotoAlt(item, { title: 'Club Mini-Thrills' }, i)}
                    loading="lazy"
                  />
                  {item.caption && <figcaption>{item.caption}</figcaption>}
                </figure>
              ))}
            </div>
            {total > items.length && (
              <p className="mt-center mt-teaser__more">
                <Link to="/galerie" className="mt-btn mt-btn--ghost">
                  Ganze Galerie ({total} Fotos)
                </Link>
              </p>
            )}
          </>
        )}
      </div>
    </section>
  );
}
